import gql from 'graphql-tag';

export const RevertContentMutation = gql`
	mutation RevertContentMutation($contentId: ID!) @experimental {
		experimentalRevertContent(contentId: $contentId)
	}
`;
